// src/components/LandingPage/NavBarPatients.tsx
"use client"

import styles from "../../../../styles/LandingPage/NavBar.module.scss"
import Image from "next/image"
import * as Scroll from "react-scroll"
import classNames from "classnames"
import { IconButton } from "@mui/material"
import Button from "../../Button/Button"
import Link from "next/link"
import React, { CSSProperties, useState } from "react"
import StyledText from "../../../typography/typography-component"
import SkinuvitaDrawer from "../../drawer/skinuvita_drawer"
import { useTranslations } from "next-intl"
import LanguageToggle from "../../LanguageToggle"
import { Routes, useTypedRouter } from "../../../data/routes"
import { TrackedActions } from "../../../tracking/trackedActions"

const NavBarPatients = ({
  scrollLinksDisabled = false,
  style,
}: {
  scrollLinksDisabled?: boolean
  style?: CSSProperties
}) => {
  const t = useTranslations("index") // namespace
  const router = useTypedRouter()
  const pathname = router.pathname
  const locale = router.locale
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <>
      <div style={style} className={styles.headerLarge}>
        <nav className={styles.topBar}>
          <div
            className={styles.bigLogo}
            onClick={() => router.push(Routes.home)}
            style={{
              cursor: "pointer",
              marginLeft: "60px",
            }}
          >
            <Image
              src={"/Skinuvita_full_logo.svg"}
              width={62}
              height={52}
              alt={t("nav.logoAlt") ?? "skinuvita logo"}
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </div>

          <div className={styles.grow} />

          {!scrollLinksDisabled && (
            <ul className={styles.tabs}>
              <li className={classNames(styles.buttons)}>
                <a
                  tabIndex={1}
                  className={classNames("stretched-link", styles.link)}
                  onClick={() => void TrackedActions.goToSelfCheck()}
                >
                  <StyledText color={"unset"} variant={"unset"}>
                    {t("nav.selfCheck")}
                  </StyledText>
                </a>
              </li>

              {locale == "de" && (
                <li className={classNames(styles.buttons)}>
                  <Link tabIndex={2} className={classNames("stretched-link", styles.link)} href={Routes.ratgeber}>
                    <StyledText color={"unset"} variant={"unset"}>
                      {t("nav.guide")}
                    </StyledText>
                  </Link>
                </li>
              )}
              {/*<li className={classNames(styles.buttons)}>*/}
              {/*  <Scroll.Link*/}
              {/*    tabIndex={3}*/}
              {/*    className={classNames("stretched-link", styles.link)}*/}
              {/*    activeClass={styles.active}*/}
              {/*    spy*/}
              {/*    smooth*/}
              {/*    offset={-100}*/}
              {/*    delay={1}*/}
              {/*    duration={500}*/}
              {/*    to={"about"}*/}
              {/*  >*/}
              {/*    <StyledText color={"unset"} variant={"unset"}>*/}
              {/*      {t("nav.aboutUs")}*/}
              {/*    </StyledText>*/}
              {/*  </Scroll.Link>*/}
              {/*</li>*/}
              <li className={classNames(styles.buttons)}>
                <Link
                  tabIndex={3}
                  className={classNames("stretched-link", styles.link)}
                  href={Routes.aboutUs}
                >
                  <StyledText color={"unset"} variant={"unset"}>
                    {t("nav.aboutUs")}
                  </StyledText>
                </Link>
              </li>

              <li className={classNames(styles.buttons)}>
                <Link tabIndex={4} className={classNames("stretched-link", styles.link)} href={Routes.team}>
                  <StyledText color={"unset"} variant={"unset"}>
                    {t("nav.team")}
                  </StyledText>
                </Link>
              </li>

              <li className={classNames(styles.buttons)}>
                <Scroll.Link
                  tabIndex={5}
                  className={classNames("stretched-link", styles.link)}
                  activeClass={styles.active}
                  spy
                  smooth
                  offset={-100}
                  delay={1}
                  duration={500}
                  to={"contact"}
                >
                  <StyledText color={"unset"} variant={"unset"}>
                    {t("nav.contact")}
                  </StyledText>
                </Scroll.Link>
              </li>

              <li style={{ paddingBottom: "10px" }} className={classNames(styles.patientButton)}>
                <Link tabIndex={6} href={pathname == Routes.doctors ? Routes.home : Routes.doctors}>
                  <Button tabIndex={-1} variant={"primary"} type={"button"} className={styles.linkButton}>
                    <StyledText className={styles.buttonText} variant={"unset"}>
                      {pathname == Routes.doctors ? t("nav.forPatients") : t("nav.forDoctors")}
                    </StyledText>
                  </Button>
                </Link>
              </li>
            </ul>
          )}
          <LanguageToggle className={styles.desktopLangToggle} />
        </nav>
      </div>

      <div className={styles.headerSmall}>
        <nav className={styles.topBar}>
          <div
            className={styles.smallLogo}
            onClick={() => router.push(Routes.home)}
            style={{
              cursor: "pointer",
              transform: "translate(10px, 5px)",
            }}
          >
            <Image
              src={"/Skinuvita_cube.svg"}
              width={24}
              height={24}
              alt={t("nav.logoAltSmall") ?? "skinuvita logo"}
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </div>

          <div className={styles.grow} />
          {/* <LanguageToggle className={styles.mobileLangToggle} /> */}

          {!scrollLinksDisabled && (
            <IconButton
              className={styles.burgerButton}
              onClick={() => setDrawerOpen(true)}
              style={{ color: "rgba(65, 145, 158, 1)" }}
              aria-label={t("nav.openMenu") ?? "open menu"}
            >
              <Image
                src={"/svg/hamburger_menu.svg"}
                alt={t("nav.openMenu") ?? "hamburger menu icon"}
                width={24}
                height={24}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </IconButton>
          )}
        </nav>
      </div>

      <SkinuvitaDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
    </>
  )
}

export default NavBarPatients
